<template>
  <div>
    <receipt-print-order ref="orders" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <receipt-print-detail ref="details"/>
  </div>
</template>

<script>
import ReceiptPrintOrder from '@/views/inbound/print/ReceiptPrintOrder.vue'
import ReceiptPrintDetail from '@/views/inbound/print/ReceiptPrintDetail.vue'
import { AsnOrder } from '@/api/dto/order/AsnOrder'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'ReceiptPrint',
  components: { ReceiptPrintDetail, ReceiptPrintOrder },
  methods: {
    refresh() {
      this.$refs.orders.refresh()
    },
    showDetails(row) {
      this.$refs.details.refresh(new AsnOrder(BaseObject.merge(row, 'asnOrder')))
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>